/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {Endorsement} from "../model/Endorsement";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class EndorsementService {

  private endorsementUrl;
  constructor(private http: HttpClient) {
    this.endorsementUrl = inject(APP_CONFIG).baseUrl + '/api/endorsements';

  }

  getAllEndorsements (): Observable<Endorsement[]> {
    const url = `${this.endorsementUrl}/all`;
    return this.http.get(url).pipe(
      map(response => response as Endorsement[] ));
  }

  addNew(newEndorsement: Endorsement): Observable<Endorsement> {
    const url = `${this.endorsementUrl}`;
    return this.http.post(url, newEndorsement, httpOptions).pipe(
      map( newEndorsement => newEndorsement as Endorsement ));
  }

  updateEndorsement(endorsement: Endorsement): Observable<Endorsement> {
    var url = `${this.endorsementUrl}/${endorsement.endorsementId}`;
    return this.http.put(url, endorsement, httpOptions).pipe(
      map( endorsement => endorsement as Endorsement ));
  }
}
